import {combineReducers} from '@reduxjs/toolkit';

import {authReducer} from 'entities/user';


import {httpMonitorReducer} from 'features/http';
import {domainMonitorReducer} from 'features/domain';
import {portMonitorReducer} from 'features/port';
import {serverReducer} from 'features/server';

import {apiReducers} from './apiRegistry';

export default combineReducers({
    authReducer,
    httpMonitorReducer,
    domainMonitorReducer,
    portMonitorReducer,
    serverReducer,
    ...apiReducers,
});
